import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Navbar } from '../navigation/Navbar';
import { Sidebar } from '../navigation/Sidebar';

const mdTheme = createTheme();

type Props = {
  children?: any;
}

export const AppLayout: React.FC<Props> = ({ children }) => {

  const isMobile = useMediaQuery(mdTheme.breakpoints.down('sm'));
  const [open, setOpen] = React.useState(false);

  const toggleSidebar = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Navbar open={open} isMobile={isMobile} toggleSidebar={toggleSidebar} />
        <Sidebar open={open} isMobile={isMobile} toggleSidebar={toggleSidebar} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: { xs: 2, sm: 4 }, mb: 4, px: { xs: 1.5, sm: 3 } }}>
            {children}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}